import { Typography } from '@material-ui/core'
import i18n from 'i18next'
import { FC } from 'react'

export interface VuokratiliPanelProps {
  t: i18n.TFunction
}

const VuokratiliPanel: FC<VuokratiliPanelProps> = ({ t }) => {
  const steps = t('apartment.vuokratiliSetupSteps', {
    returnObjects: true
  }) as string[]
  const storeUrl = t('apartment.vuokratiliSetupStoreUrl')

  return (
    <div style={{ minWidth: 0, overflowWrap: 'break-word', wordBreak: 'break-word' }}>
      <Typography paragraph style={{ overflowWrap: 'break-word' }}>
        {t('apartment.vuokratiliPanelContent')}
      </Typography>
      <Typography
        variant='subtitle1'
        gutterBottom
        style={{ fontWeight: 700 }}
      >
        {t('apartment.vuokratiliSetupHeader')}
      </Typography>
      <Typography
        component='ol'
        style={{ paddingLeft: 20, margin: 0, overflowWrap: 'break-word' }}
      >
        {steps.map((step, index) => (
          <li key={index} style={{ marginBottom: 8 }}>
            {step}
            {index === 0 && (
              <>
                <br />
                <a
                  href={storeUrl}
                  target='_blank'
                  rel='noopener noreferrer'
                  style={{
                    display: 'inline-block',
                    maxWidth: '100%',
                    wordBreak: 'break-all',
                    overflowWrap: 'anywhere'
                  }}
                >
                  {storeUrl}
                </a>
              </>
            )}
          </li>
        ))}
      </Typography>
    </div>
  )
}

export default VuokratiliPanel
